import React from "react";
import { type BlockOut, blockOutTypes } from "../scheduleData";
import { BlockOutModal } from "./BlockOutModal";

interface BlockOutCardProps {
  blockOut: BlockOut;
  onEdit: (blockOutId: string, data: any) => void;
  onDelete?: (blockOutId: string) => void;
  size?: "small" | "medium" | "large";
  isDarkMode?: boolean;
}

export function BlockOutCard({
  blockOut,
  onEdit,
  onDelete,
  size = "medium",
  isDarkMode = false,
}: BlockOutCardProps) {
  const largeContent = (
    <div
      data-blockout-card
      className="group relative pointer-events-auto mb-2"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`p-3 rounded-lg cursor-pointer hover:opacity-80 ${blockOut.color} relative overflow-hidden`}
        title={`${blockOut.title} - ${blockOut.startTime} to ${blockOut.endTime}`}
        style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 3px,
            rgba(255,255,255,0.3) 3px,
            rgba(255,255,255,0.3) 6px
          )`,
        }}
      >
        <div className="flex items-center justify-between">
          <div>
            <div className="font-medium">
              {blockOut.startTime} - {blockOut.endTime}
            </div>
            <div className="text-sm opacity-90 font-semibold">
              🚫 {blockOut.title}
            </div>
            <div className="text-sm opacity-75">
              Type:{" "}
              {blockOutTypes.find((t) => t.value === blockOut.type)?.label}
            </div>
            {blockOut.description && (
              <div className="text-sm opacity-75 italic">
                {blockOut.description}
              </div>
            )}
          </div>
          <div className="text-sm font-medium opacity-75">BLOCKED</div>
        </div>
      </div>
    </div>
  );

  const smallMediumContent = (
    <div
      data-blockout-card
      className="group relative pointer-events-auto"
      onClick={(e) => e.stopPropagation()}
    >
      <div
        className={`text-xs p-1 rounded cursor-pointer hover:opacity-80 ${blockOut.color} relative overflow-hidden`}
        title={`${blockOut.title} - ${blockOut.startTime} to ${blockOut.endTime}`}
        style={{
          backgroundImage: `repeating-linear-gradient(
            45deg,
            transparent,
            transparent 2px,
            rgba(255,255,255,0.3) 2px,
            rgba(255,255,255,0.3) 4px
          )`,
        }}
      >
        <div className="font-medium truncate text-center">
          {size === "small"
            ? blockOut.title
            : `${blockOut.startTime} - ${blockOut.title}`}
        </div>
      </div>
    </div>
  );

  const trigger = size === "large" ? largeContent : smallMediumContent;

  return (
    <BlockOutModal
      trigger={trigger}
      editMode={blockOut}
      onSave={(data) => onEdit(blockOut.id, data, (blockOut as any).otherPharmacyId)}
      onDelete={(id?: string, otherPharmacyId?: string) => onDelete?.(id || blockOut.id, otherPharmacyId || (blockOut as any).otherPharmacyId)}
      isDarkMode={isDarkMode}
    />
  );
}
